<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>重大危险源</el-breadcrumb-item>
            <el-breadcrumb-item>升降机监测</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 循环部分 -->
          <div class="secend_content" v-for="(item,i) in list" :key="i">
            <div class="entRisk_content">
              <div class="th_one">
                <div>设备编号：{{item.device_id}}</div>
                <div>监测位置：{{item.name}}</div>
              </div>
              <div>
                联网状态:
                <span
                  style="color:#36C635"
                  v-if="item.connectedStatus=='正常联网'"
                >{{item.connectedStatus}}</span>
                <span
                  style="color:#707070"
                  v-if="item.connectedStatus=='离线'"
                >{{item.connectedStatus}}</span>
              </div>
              <div>时间：{{item.update_date}}</div>
              <div class="th_one">
                <div>
                  超重监测
                  <!-- <span style="color:#36C635" v-if="item.system_status_weight==0">正常</span>
            <span style="color:#36C635" v-if="item.system_status_weight==1">预警</span>
                  <span style="color:#36C635" v-if="item.system_status_weight==2">报警</span>-->
                  <span style="color:#36C635">{{item.weight}}</span>
                </div>
                <div>
                  速度监测
                  <span style="color:#36C635">{{item.speed}}</span>
                </div>
                <div>
                  倾斜监测
                  <span style="color:#36C635">{{item.tilt}}</span>
                </div>
                <!-- <div>
            碰撞监测
            <span style="color:#C3F305"></span>
                </div>-->
              </div>
              <div style="position:relative">
                <img
                  v-if="item.connectedStatus=='离线'"
                  class="round"
                  src="../../assets/image/round.png"
                  alt
                />
                <img
                  v-if="item.connectedStatus=='正常联网'"
                  class="round round_normal"
                  src="../../assets/image/round.png"
                  alt
                />
                <img class="blue" src="../../assets/image/white.png" alt />
                <div style="position: absolute;top: 64px;left: 64px;color:#6b6b6b">
                  <div v-if="item.connectedStatus=='离线'">{{item.connectedStatus}}</div>
                  <div v-else>正常</div>
                  <div>24小时</div>
                </div>
              </div>
              <div>
                <el-button v-if="item.tzStatus>0" type="warning" @click="node(item.deviceId)">通知处理</el-button>
              </div>
            </div>
            <div style="text-align:left;padding:0 50px">特种操作人员：</div>
            <div v-for="(item1,i) in item.teamsPersonList" :key="i">
              <el-row :gutter="20" class="spealic">
                <!-- <div>{{item.personName}}</div> -->
                <el-col :span="6">
                  <div class="grid-content bg-purple">{{item1.personName}}</div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">证号{{item1.certificateNumber}}</div>
                </el-col>
                <el-col :span="6">
                  <div
                    class="grid-content bg-purple hand"
                    @click="cred(item1.certificatePhoto)"
                  >查看证书</div>
                </el-col>
                <el-col :span="6">
                  <div
                    class="grid-content bg-purple hand"
                    @click="record(item1.person_id,item.id)"
                  >操作记录</div>
                </el-col>
              </el-row>

              <el-dialog
                title="证书"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose"
              >
                <span>
                  <img :src="img" alt />
                </span>
              </el-dialog>
            </div>
          </div>
          <div v-if="nodata" class="imgs">
            <img src="../../assets/image/noData.png" alt />
            <div>暂无数据</div>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      secondTitle: '',
      groupId: '',
      prevPage: '', //上一个页面
      // istowe: true,
      list: [],
      personList: [],
      curTime: util.myTime.formatTime(new Date(), 'YYYY年MM月dd日 HH:mm:ss'),
      nodata: false,
      istower: true,
      istowerPro: false,
      port: '',
      y: '1'
    }
  },
  mounted() {
    this.port = util.session.get('roleId')
    if (this.port == '4') {
      this.groupId = util.session.get('groupId')
      this.istower = false
      this.getData()
    }
    if (this.$route.name == 'deepPro' && this.port == '4') {
      this.istowerPro = true
    } else {
      this.istowerPro = false
    }
    if (util.session.get('proId')) {
      this.groupId = util.session.get('proId')
    }

    // this.getData()
  },
  methods: {
    //获取数据

    getData() {
      var that = this
      myHttp
        .getTowerListByProjectId({
          projectId: this.groupId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              // console.log(resp.data)
              var list = resp.data.data.towerList || []
              for (var i = 0; i < list.length; i++) {
                var personList = list[i].teamsPersonList || []
                // console.log(list,personList)
              }
              that.list = list
              that.personList = personList
              if (list.length == 0) {
                that.nodata = true
              }
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    node() {
      // console.log(deviceId)
      // var that = this
      // myHttp
      //   .updateInformStatus({
      //     projectId: this.groupId,
      //     deviceId: deviceId
      //   })
      //   .then(
      //     function(resp) {
      //       if (resp.data.code == '200') {
      //         that.$message({
      //           type: 'success',
      //           message: '操作成功'
      //         })
      //         that.getData()
      //       } else {
      //         that.$message.error(resp.data.msg)
      //       }
      //     },
      //     function() {}
      //   )
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      this.y = 0
    },
    goBack() {
      this.$router.go(-1)
      //window.history.back()
    }
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.secend_content {
  margin-top: 30px;
  margin-bottom: 30px;
  background: #f5f5f5;
  padding: 0 50px;
  overflow: hidden;
}
.entRisk_content {
  width: 95%;
  /* height: ; */
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid #f5f5f5;
}
.entRisk_bot {
  width: 95%;
  background: #011c56;
}
.left_head {
  /* width: 20%; */
  display: flex;
  color: #fff;
}
.th_one {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 30%;
  text-align: left;
}
.spealic {
  background: #fff;
  padding: 0 36px;
  display: flex;
  width: 98%;
  margin: 0 auto;
  /* padding-bottom: 30px; */
  height: 60px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 10px;
}
.round {
  display: block;
  position: absolute;
  display: block;
}
.round_normal {
  animation: rotate 6s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotateZ(0deg); /*从0度开始*/
  }
  100% {
    transform: rotateZ(360deg); /*360度结束*/
  }
}
.text {
  text-align: left;
}
.hand {
  cursor: pointer;
}
.hand:hover {
  color: #0085ff;
}
.imgs {
  width: 100%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  border: 1px solid #000;
}
.imgs > img {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.imgs > div {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-60%, -50%);
  font-weight: bolder;
  color: #6b6b6b;
}
</style>